import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth, googleProvider } from '../firebase/config';
import { signInWithPopup, signOut, onAuthStateChanged } from 'firebase/auth';
import { getClientProfile, checkAdminStatus } from '../firebase/clientService';

const AuthContext = createContext();

export const useAuth = () => {
    return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
            if (currentUser) {
                try {
                    // 1. Intentar obtener perfil de cliente
                    const clientData = await getClientProfile();
                    
                    if (clientData) {
                        // Es un cliente
                        setUser({
                            uid: currentUser.uid,
                            id: clientData.ClienteId, // SQL ID
                            displayName: currentUser.displayName,
                            email: currentUser.email,
                            photoURL: currentUser.photoURL,
                            company: clientData.company,
                            role: 'Client', 
                            campusEnabled: clientData.campusEnabled,
                            subscriptionEnabled: clientData.subscriptionEnabled,
                            plan: clientData.plan,
                            subscriptions: clientData.subscriptions
                        });
                    } else {
                        // 2. Si no es cliente, verificar si es admin
                        const isAdmin = await checkAdminStatus();
                        if (isAdmin) {
                            setUser({
                                uid: currentUser.uid,
                                displayName: currentUser.displayName,
                                email: currentUser.email,
                                photoURL: currentUser.photoURL,
                                role: 'Admin'
                            });
                        } else {
                            // Usuario no autorizado
                            console.warn(`Acceso denegado para: ${currentUser.email}`);
                            await signOut(auth);
                            setUser(null);
                        }
                    }
                } catch (error) {
                    console.error("Error verificando autorización:", error);
                    setUser(null);
                }
            } else {
                setUser(null);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    const loginWithGoogle = async () => {
        try {
            // Forzar la selección de cuenta cada vez
            googleProvider.setCustomParameters({
                prompt: 'select_account'
            });
            
            const result = await signInWithPopup(auth, googleProvider);
            // La verificación real ocurre en el onAuthStateChanged, 
            // pero podemos hacer una verificación preliminar aquí si quisiéramos.
            // Por ahora confiamos en el listener de estado.
            
            return result.user;
        } catch (error) {
            console.error("Error en login con Google:", error);
            throw error;
        }
    };

    const logout = async () => {
        try {
            console.log("Cerrando sesión...");
            await signOut(auth);
            setUser(null);
            console.log("Sesión cerrada correctamente.");
        } catch (error) {
            console.error("Error al cerrar sesión:", error);
        }
    };

    const value = {
        user,
        loginWithGoogle,
        logout,
        loading
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};